import i18n from '@/natives/libs/i18n';
import { WHAT_THEY_SAY } from './const';

const itemWidth = 434;
let currentLeft = -itemWidth * 2;
let temp = -itemWidth * 2;
let testimonyList = [];

document.querySelector('.btn-left').addEventListener('click', function () {
  temp = currentLeft;
  currentLeft += itemWidth;
  if (currentLeft > 0) {
    currentLeft = -itemWidth * (testimonyList.length - 3 - 1);
  }
  setLeft(currentLeft, temp);
});
document.querySelector('.btn-right').addEventListener('click', function () {
  temp = currentLeft;
  currentLeft -= itemWidth;
  if (Math.abs(currentLeft) > itemWidth * (testimonyList.length - 3)) {
    currentLeft = -itemWidth;
  }
  setLeft(currentLeft, temp);
});

function setLeft(left, temp) {
  const warapper = document.querySelector('#what-they-say-wrapper');
  warapper.style.left = `${left }px`;
  const criticalValue = (testimonyList.length - 3) * itemWidth;
  //   重置初始位置，避免大幅度滑动
  if (temp === -criticalValue) {
    temp = 0;
  } else if (temp === 0) {
    temp = -criticalValue;
  }
  warapper.animate([{ left: `${temp }px` }, { left: `${left }px` }], 300);
}

function initData() {
  const data = WHAT_THEY_SAY;
  const videoMap = data.videoList.reduce((obj, item) => {
    obj[item.countryKey] = item;
    return obj;
  }, {});
  testimonyList = data.pictureList
    .sort(() => Math.random() - 0.5)
    .filter((item) => {
      return item.isShow;
    })
    .map((item) => {
      item.subTitle = i18n
        .t('testimony_images_title')
        .replace('{0}', item.subTitleKey)
        .replace('{1}', i18n.t(item.countryKey)); // 增加国家多语言
      const videoData = videoMap[item.countryKey];
      if (videoData) {
        item.videoData = videoData;
      }
      return item;
    });
  testimonyList = [...testimonyList.slice(-2), ...testimonyList, testimonyList[0]];
  getList(testimonyList);
}
function getList(testimonyList) {
  const box = document.querySelector('#what-they-say-wrapper');
  let str = '';
  //
  testimonyList.forEach((item) => {
    str += `
    <div class="card-item">
        <div class="card-item-box">`;
    if (item.videoData) {
      str += ` <a
                class="card-item-box-video"
                href="${item.videoData.videoPath}"
                target="_blank"
              >
                <img class="card-item-box-img" src="${item.videoData.videoThumbnail}" alt="">
                <img class="card-item-box-icon" src="/assets/img/icon-play.svg" alt="">
              </a>`;
    } else {
      str += `
            <img class="card-item-box-img" src="${item.picturePath}" alt="">
            <p class="card-item-box-title" title="${item.titleKey}">${item.titleKey}</p>
            <p class="card-item-box-tips" title="${item.subTitle}">${item.subTitle}</p>
            `;
    }

    str += `</div><div class="card-item-content">
            <div class="card-item-content-tips" title="${i18n.t(item.contentKey)}">${i18n.t(item.contentKey)}</div>
        </div>
    </div>
    `;
  });
  box.innerHTML = str;
}
/**
 * mounted
 */
(function () {
  initData();
})();
